// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-x-corner.js';

import { paths } from '../generated/file-x-corner';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-x-corner', Original, paths);
